// extracted by mini-css-extract-plugin
export default {"emptyListContainer":"empty_emptyListContainer__uOLra"};